import { Platform } from 'react-native';
import icons from '../components/Icon/icons';
import { Image } from 'react-native';
export const iconIsImage = (icon) => {
    if (!icon) {
        return false;
    }
    const URL_REGULAR_EXPRESSION = /(http|https):\/\/([\w.]+\/?)\S*/gi;
    return icon.match(URL_REGULAR_EXPRESSION);
};
export const objectMerge = (arr) => {
    if (!Array.isArray(arr)) {
        return arr;
    }
    return arr.reduce((prev, curr) => {
        return Object.assign(Object.assign({}, prev), curr);
    }, {});
};
export const parseSideSpace = (props) => {
    const { sideSpace, getRem } = props;
    const result = { top: 0, right: 0, bottom: 0, left: 0 };
    if (!sideSpace) {
        return result;
    }
    const arr = sideSpace
        .toString()
        .split(' ')
        .map((v) => {
        let r = Number.parseInt(v, 10);
        if (getRem) {
            r = getRem(r);
        }
        return r;
    });
    switch (arr.length) {
        case 4:
            return { top: arr[0], right: arr[1], bottom: arr[2], left: arr[3] };
        case 3:
            return { top: arr[0], right: arr[1], bottom: arr[2], left: arr[1] };
        case 2:
            return { top: arr[0], right: arr[1], bottom: arr[0], left: arr[1] };
        case 1:
            return { top: arr[0], right: arr[0], bottom: arr[0], left: arr[0] };
        default:
            return result;
    }
};
export const isIOS = Platform.OS === 'web'
    ? !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    : Platform.OS === 'ios';
let hasInjectWebCss = false;
// web场景下去除Input、TextArea组件的outline，适配Stepper样式
export const injectWebCss = () => {
    if (Platform.OS !== 'web' || hasInjectWebCss) {
        return;
    }
    hasInjectWebCss = true;
    const style = document.createElement('style');
    style.textContent = `
    textarea, input { outline: none }
    .Stepper-input-wrap {
        position: absolute;
        top: 0;
    }
    .Stepper-textInput {
        position: absolute;
        top: 0;
        width: 100%;
        flex-shrink: 1;
        flex-grow: 0;
        justify-content: center;
        align-items: stretch;
        text-align: center;
        border: none;
        -moz-appearance: textfield;
    }
    .Stepper-textInput::-webkit-outer-spin-button,
    .Stepper-textInput::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    .Stepper-textInput:focus {
        border: none;
    }`;
    return document.head.appendChild(style);
};
export const isWeb = Platform.OS === 'web';
export const getIconName2Url = (iconName, mode) => {
    if (iconName) {
        if (icons[iconName]) {
            return (icons[iconName][mode + 'Url'] ||
                icons[iconName][mode + 'PngUrl'] ||
                '');
        }
        else {
            console.warn(`无效的iconName: ${iconName}, 可用的图标参考: https://kid.corp.kuaishou.com/kid/icon/collections/all?businessId=26`);
        }
    }
    else {
        console.warn('请传入有效的图标uri或name');
        return '';
    }
};
export const prefetchImage = (names, mode) => {
    names.forEach((name) => {
        Image.prefetch(getIconName2Url(name, mode))
            .then(() => { })
            .catch((err) => console.log(`${name} prefetch error: ${err}`));
    });
};
export const isShowInText = (content) => {
    return typeof content === 'string' || typeof content === 'number';
};
export const isInteger = (value) => {
    return Math.floor(value) === value;
};
export const omit = (value, keys) => {
    let target = {};
    for (let i in value) {
        if (keys.indexOf(i) >= 0 ||
            !Object.prototype.hasOwnProperty.call(value, i)) {
            continue;
        }
        else {
            target[i] = value[i];
        }
    }
    return target;
};
